const NOT_FOUND_STATUS_CODE = 404;
const UNAUTHORIZED_STATUS_CODE = 401;
export const STATUS_CODES_TO_IGNORE = [NOT_FOUND_STATUS_CODE, UNAUTHORIZED_STATUS_CODE];